// Refresh time in milliseconds (e.g., 60 seconds)
export const Refresh_time = 120 * 1000;
